import { useState, useEffect } from 'react';
import { FaStop, FaRegStopCircle } from 'react-icons/fa';
import { Button } from '../input';
import { Loading } from '../loading';
import { useJob } from '../../state/jobs';

export const StopButton = ({ job, size }) => {
  size ||= 16;

  const { api } = useJob(job?.id);
  const [running, setRunning] = useState();
  const [stopping, setStopping] = useState();

  const loading = stopping;

  useEffect(() => {
    if (['active'].includes(job?.state)) {
      setRunning(true);
    } else {
      setRunning(false);
    }

    if (['completed', 'failed'].includes(job?.state)) {
      setStopping(false);
    }
  }, [job?.state]);

  const handleStop = async (e) => {
    e.stopPropagation();

    const data = await api.stop();
    setStopping(true);
    console.log('stop gave:', data);
  };

  if (!running) {
    return null;
  }

  const inner = (
    <div
      style={{
        width: size,
        height: size,
        border: '0px solid red',
        background: '#ddd',
        borderRadius: size,
        position: 'relative',
        cursor: 'pointer',
      }}
      onClick={handleStop}
    >
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          top: 0,
          left: 0,
          width: size,
          height: size,
        }}
      >
        {!loading && <FaStop size={size / 2} />}
      </div>
    </div>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      {!stopping && inner}
      {stopping && <span>Stopping...</span>}
    </div>
  );

  return (
    <div>
      <div
        style={{ borderRadius: 20, width: 10, height: 10 }}
        small
        grayFlat
        loadingx={true}
        disabledx={stopping || job?.state != 'active'}
        onClick={handleStop}
      >
        <div>
          <FaStop size={5} />
        </div>
      </div>
    </div>
  );
};
